export const BankListCode = {
	'10264663': '081',
	'10371492': '475',
	'10398952': '133',
	'10573521': '323',
	'10663610': '577',
	'10664513': '121',
	'10690848': '083',
	'10853017': '138',
	'10866788': '024',
	'11165756': '384',
	'11285104': '426',
	'11351086': '576',
	'11476673': '088',
	'11495073': '319',
	'11581339': '274',
	'11703662': '095',
	'11758741': '094',
	'11760553': '478',
	'11970623': '276',
	'12392983': '447',
	'12473687': '569',
	'12865507': '092',
	'13009717': '047',
	'13059145': '144',
	'13140088': '332',
	'13203354': '450',
	'13220493': '126',
	'13293225': '325',
	'13370835': '301',
	'13486793': '173',
	'13673855': '331',
	'13720915': '119',
	'13884775': '396',
	'13935893': '509',
	'14190547': '309',
	'14388334': '254',
	'14511781': '268',
	'15111975': '401',
	'15114366': '107',
	'15124464': '334',
	'15173776': '412',
	'15357060': '124',
	'15489568': '549',
	'15581638': '149',
	'16501555': '197',
	'16695922': '439',
	'16927221': '313',
	'16944141': '142',
	'17079937': '529',
	'17184037': '389',
	'17298092': '184',
	'17351180': '634',
	'17352220': '545',
	'17453575': '132',
	'17772370': '298',
	'17826860': '377',
	'18188384': '321',
	'18189547': '542',
	'18236120': '260',
	'18394228': '470',
	'18520834': '129',
	'18684408': '562',
	'19307785': '128',
	'19324634': '416',
	'19468242': '595',
	'19540550': '461',
	'20155248': '194',
	'20251847': '538',
	'20308187': '588',
	'20757199': '561',
	'20855875': '536',
	'21018182': '383',
	'21332862': '324',
	'21995256': '560',
	'22575466': '533',
	'22610500': '310',
	'22896431': '380',
	'23114447': '566',
	'23522214': '163',
	'23862762': '280',
	'24074692': '146',
	'24537861': '343',
	'26563270': '279',
	'27084098': '593',
	'27098060': '335',
	'27214112': '349',
	'27302181': '427',
	'27351731': '374',
	'27652684': '278',
	'27842177': '271',
	'28127603': '021',
	'28195667': '246',
	'28650236': '292',
	'28811341': '554',
	'29030467': '751',
	'29162769': '352',
	'30306294': '208',
	'30680829': '386',
	'30723886': '746',
	'30944783': '557',
	'30980539': '546',
	'31597552': '241',
	'31749596': '398',
	'31872495': '336',
	'31880826': '612',
	'31895683': '604',
	'32062580': '505',
	'32074986': '550',
	'32192325': '552',
	'32402502': '329',
	'32648370': '196',
	'32997490': '342',
	'33040601': '567',
	'33042151': '300',
	'33042953': '477',
	'33132044': '266',
	'33147315': '122',
	'33172537': '376',
	'33264668': '348',
	'33466988': '473',
	'33479023': '745',
	'33603457': '120',
	'33644196': '265',
	'33657248': '007',
	'33667205': '583',
	'33737818': '582',
	'33775974': '188',
	'33862244': '134',
	'33885724': '029',
	'33886862': '467',
	'33923798': '243',
	'34088029': '397',
	'34111187': '078',
	'34265629': '525',
	'34335592': '355',
	'34337707': '531',
	'34711571': '367',
	'34747388': '597',
	'34829992': '528',
	'35551187': '445',
	'35810871': '586',
	'35977097': '373',
	'36113876': '111',
	'36266751': '512',
	'36583700': '516',
	'36586946': '408',
	'36864992': '484',
	'36947229': '402',
	'37229413': '507',
	'37241230': '404',
	'37414009': '418',
	'37526080': '414',
	'37555231': '449',
	'37679449': '518',
	'37715993': '406',
	'37880206': '403',
	'38129006': '419',
	'38224857': '435',
	'38429045': '455',
	'38593706': '544',
	'39343350': '421',
	'39416705': '443',
	'39519944': '535',
	'39587424': '457',
	'39664698': '428',
	'39669186': '448',
	'39676772': '452',
	'39738065': '510',
	'39908427': '462',
	'40083667': '465',
	'40276692': '563',
	'40303299': '306',
	'40333582': '556',
	'40353377': '305',
	'40434681': '463',
	'40473435': '590',
	'40475846': '451',
	'40654622': '444',
	'40768766': '519',
	'41592532': '454',
	'42047025': '460',
	'42066258': '506',
	'42259084': '482',
	'42272526': '017',
	'43180355': '174',
	'43599047': '481',
	'44019481': '521',
	'44077014': '433',
	'44189447': '495',
	'44292580': '523',
	'44478623': '527',
	'44683140': '511',
	'44705774': '520',
	'44728700': '513',
	'45246410': '125',
	'45331622': '547',
	'45745537': '532',
	'45756448': '537',
	'45854066': '524',
	'46026562': '526',
	'46518205': '488',
	'46955383': '558',
	'47593544': '522',
	'47873449': '530',
	'48703388': '594',
	'48707451': '553',
	'48795256': '065',
	'49288113': '559',
	'49336860': '492',
	'49555647': '579',
	'49933388': '568',
	'50579044': '145',
	'50585090': '250',
	'51342763': '620',
	'51414521': '572',
	'52904364': '354',
	'52937216': '253',
	'53518684': '269',
	'54403563': '213',
	'55230916': '139',
	'57839805': '018',
	'58160789': '422',
	'58497702': '630',
	'58616418': '224',
	'59109165': '393',
	'59118133': '600',
	'59274605': '390',
	'20018183': '462',
	'59285411': '623',
	'59588111': '655',
	'60394079': '479',
	'60498557': '456',
	'60518222': '464',
	'60701190': '341',
	'60746948': '237',
	'60814191': '381',
	'60850229': '613',
	'60872504': '652',
	'60889128': '637',
	'61024352': '653',
	'61033106': '069',
	'61088183': '370',
	'61182408': '249',
	'61186680': '318',
	'61348538': '626',
	'61384004': '508',
	'61444949': '270',
	'61533584': '366',
	'61723847': '113',
	'61747085': '131',
	'61809182': '011',
	'61820817': '611',
	'62073200': '755',
	'62109566': '089',
	'62144175': '643',
	'62169875': '140',
	'62232889': '707',
	'62237649': '288',
	'62285390': '363',
	'62287735': '101',
	'62331228': '487',
	'62421979': '233',
	'65913436': '177',
	'67030395': '438',
	'68757681': '365',
	'68900810': '633',
	'70119680': '581',
	'71027866': '218',
	'71590442': '293',
	'71677850': '285',
	'73302408': '514',
	'73622748': '080',
	'74014747': '565',
	'74828799': '753',
	'75647891': '222',
	'76461557': '281',
	'76543115': '754',
	'76641497': '311',
	'78157146': '098',
	'78626983': '610',
	'78632767': '712',
	'80230774': '584',
	'80271455': '720',
	'81723108': '010',
	'82096447': '440',
	'87437687': '580',
	'87963450': '442',
	'89960090': '283',
	'90400888': '033',
	'91884981': '217',
	'92702067': '041',
	'92825397': '543',
	'92856905': '117',
	'92874270': '654',
	'92875780': '371',
	'92894922': '212',
	'94968518': '289',
	'00000000': '001',
	'04902979': '003',
	'07237373': '004',
	'04866275': '012',
	'09274232': '014',
	'02819125': '015',
	'04715685': '016',
	'03323840': '025',
	'06271464': '036',
	'04913711': '037',
	'03609817': '040',
	'04913129': '060',
	'03012230': '062',
	'04184779': '063',
	'04332281': '064',
	'02801938': '066',
	'00000208': '070',
	'03017677': '074',
	'03532415': '075',
	'07656500': '076',
	'00416968': '077',
	'09516419': '079',
	'07679404': '082',
	'02398976': '084',
	'05463212': '085',
	'01634601': '091',
	'07945233': '093',
	'00997185': '096',
	'04632856': '097',
	'03046391': '099',
	'00806535': '100',
	'02332886': '102',
	'00360305': '104',
	'07652226': '105',
	'01800019': '108',
	'05790149': '114',
	'09512542': '127',
	'09313766': '130',
	'00315557': '136',
	'09526594': '141',
	'02992317': '143',
	'09105360': '157',
	'05442029': '159',
	'02685483': '180',
	'09210106': '183',
	'07512441': '189',
	'03973814': '190',
	'04257795': '191',
	'07799277': '195',
	'08609934': '259',
	'00250699': '272',
	'08253539': '273',
	'07853842': '286',
	'08561701': '290',
	'04062902': '296',
	'04814563': '299',
	'03751794': '307',
	'07693858': '312',
	'03502968': '315',
	'07450604': '320',
	'01073966': '322',
	'03311443': '326',
	'05841967': '328',
	'00556603': '330',
	'09554480': '340',
	'01330387': '350',
	'09464032': '358',
	'05351887': '359',
	'02276653': '360',
	'01027058': '362',
	'09089356': '364',
	'08357240': '368',
	'01852137': '378',
	'01658426': '379',
	'04307598': '382',
	'03844699': '385',
	'03215790': '387',
	'08240446': '391',
	'07207996': '394',
	'08673569': '395',
	'01701201': '399',
	'05491616': '400',
	'00329598': '407',
	'05684234': '410',
	'05192316': '411',
	'01858774': '413',
	'00460065': '423',
	'03881423': '425',
	'05676026': '429',
	'00204963': '430',
	'07253654': '458',
	'04546162': '459',
	'04862600': '468',
	'07138049': '469',
	'04831810': '471',
	'00714671': '534',
	'00122327': '539',
	'04849745': '540',
	'00954288': '541',
	'06249129': '548',
	'02682287': '555',
	'01235921': '578',
	'00558456': '739',
	'00517645': '741',
	'00795423': '743',
	'01023570': '747',
	'01181521': '748',
	'79342069': '748', //COOP SICREDI DEXIS aparentemente não tem código de banco
	'01522368': '752',
	'02038232': '756',
	'02318507': '757',
	'36741675': '000',
	'37511258': '000',
	'33630661': '000',
	'87733770': '000',
	'07268499': '000',
	'32343119': '000',
	'11275560': '000',
	'33449007': '000',
	'24313102': '769',
};
